module.exports = __webpack_public_path__ + "static/media/report-impact-destination.d3d1a543.jpg";